module.exports = __webpack_public_path__ + "static/media/downloadSolid.c8bc4351.svg";